

import { useSelector } from 'react-redux';
import { BarChart as BC, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Bar } from 'recharts';
import CustomTooltip from './CustomTooltip';

const BarChart = ({ data, width, height, fontSize = "12px", dataKeys, mainDataKey  }) => {
    const { theme } = useSelector((state) => state.layout)
    return (
            <ResponsiveContainer width="100%" height="100%">
                <BC  data={data}>
                    <CartesianGrid strokeDasharray="3 3" stroke={theme === "light" ? "#323131" : "#fff"} opacity={0.3} />
                    <XAxis dataKey={mainDataKey} fontSize={fontSize} tick={{ fill: theme === "light" ? "#000": '#fff' }}/>
                    <YAxis fontSize={fontSize} tickLine={false} tickCount={7} tickFormatter={(number) => `%${number}`}  tick={{ fill: theme === "light" ? "#000": '#fff' }} />
                    <Tooltip content={<CustomTooltip type={"yogunluk"} />} />
                    <Bar dataKey="loadDensity" fill="#EBB00E" />
                    <Bar dataKey="vehicleDensity" fill="#8c98bc" />
                </BC>
            </ResponsiveContainer>
    )
}

export default BarChart